import classNames from 'classnames';

import { DrawerFormLayoutProps } from './drawer-form-layout.type';

/**
 * Scrollable scaffold shared by the offer-chassis form drawers (add-on, admission, preset, pass):
 * a full-height column with a fixed `header`, a scrollable body and a fixed `footer`. The drawer
 * shell (`OfferFormDrawer`) sets `bodyScrollable={false}` and delegates the scroll here, so this is
 * the single owner of `data-main-scroll` (Android pull-to-refresh, handbook §10) and the body's
 * `overflow-y-auto`. The root is a `<form>` wired to `onSubmit` (RHF `handleSubmit`) so Enter submits.
 */
export const DrawerFormLayout = ({
  onSubmit,
  header,
  footer,
  children,
  testId,
  bodyClassName,
}: DrawerFormLayoutProps): JSX.Element => (
  <form onSubmit={onSubmit} data-testid={testId} className='flex h-full flex-col'>
    {header}
    <div data-main-scroll className={classNames('scrollbar-xceed flex-1 overflow-y-auto px-4 xs:px-10', bodyClassName)}>
      {children}
    </div>
    {footer}
  </form>
);
